/** @format */
import ProductPage from './product';

export { getServerSideProps } from './product';
export default ProductPage;
